import { render } from "./DialogModel.vue?vue&type=template&id=42fdaa18&scoped=true"
import script from "./DialogModel.vue?vue&type=script&lang=js"
export * from "./DialogModel.vue?vue&type=script&lang=js"

import "./DialogModel.vue?vue&type=style&index=0&id=42fdaa18&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42fdaa18"]])

export default __exports__